import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as actions from './redux/actions';
import ChartWrapper from "../home/ChartWrapper";
import moment from 'moment';
import 'moment/locale/de';

export class Graphs extends Component {
    static propTypes = {
        products: PropTypes.object.isRequired,
        customers: PropTypes.array.isRequired,
        actions: PropTypes.object.isRequired,
    };

    getGraphData = (user, product) => {
        const productExercises = user.exerciseResults[product];
        let exams = productExercises.filter((exercise) => (exercise.type === 'exam'));
        let exercises = productExercises.filter((exercise) => (exercise.type === 'exercise'));
        let specificExercises = {};
        exercises.forEach((exercise) => {
            if (!specificExercises[exercise.exercise_id]) {
                specificExercises[exercise.exercise_id] = {exercises: [exercise]};
            } else {
                specificExercises[exercise.exercise_id].exercises.push(exercise);
            }
        });
        return {
            exams: exams.slice(Math.max(exams.length - 50, 0)),
            specificExercises,
            loginTimes: user.loginTimes,
        };
    };

    buildExerciseData = (dataArr, label, labels) => {
        const examColors = dataArr.map(e => {
            if (e.rating > 49) return '#a0ce4e';
            if (e.rating < 50) return '#FF6839';
        });
        let examChart = {
            labels: labels,
            datasets: [
                {
                    label: [label],
                    backgroundColor: examColors,
                    borderColor: examColors,
                    pointColor: examColors,
                    strokeColor: examColors,
                    fillColor: examColors,
                    fill: true,
                    borderWidth: 1,
                    hoverBackgroundColor: examColors,
                    hoverBorderColor: examColors,
                    data: dataArr.map(exam => (exam.rating !== '0' ? exam.rating : '1')),
                },
            ],
        };
        return examChart;
    };

    buildLoginTimesData = (loginTimes, labels) => {
        let yearMonth = '';
        if (loginTimes[0] && loginTimes[0].created) {
            yearMonth = moment(loginTimes[0].created).locale('de').format('MMMM Y');
        }
        let loginTimeChart = {
            labels: labels,
            datasets: [
                {
                    label: `Anmeldezeiten ab ${yearMonth} (4 Monate rückblickend)`,
                    backgroundColor: '#a0ce4e',
                    borderColor: '#a0ce4e',
                    pointColor: '#a0ce4e',
                    strokeColor: '#a0ce4e',
                    fillColor: '#a0ce4e',
                    fill: true,
                    borderWidth: 1,
                    hoverBackgroundColor: '#a0ce4e',
                    hoverBorderColor: '#a0ce4e',
                    data: loginTimes.map(login => (login.minutes)),
                },
            ],
        };
        return loginTimeChart;
    };

    render() {
        const {customers, match: {params: {name, userId}}} = this.props;
        const user = customers.find((customer) => (customer.user_id === userId));
        const graphData = this.getGraphData(user, name);
        const examLabels = graphData.exams.map((e) => (`Punkte: ${e.rating}\nStart: ${moment(e.started).format('D.M.Y HH:mm:ss')}\nAbgegeben: ${moment(e.finished).format('D.M.Y HH:mm:ss')}`));
        return (
            <div className="content-animate">
                <h1>Statistiken ({`${user.first_name} ${user.last_name}`})</h1>
                <div className="row">
                    {graphData.loginTimes.map((login, i) => (
                        <ChartWrapper
                            key={`login-time-chart${i}`}
                            data={this.buildLoginTimesData(login, login.map(e => `Loginzeit: ${e.time}\nStart: ${moment(e.created).format('D.M.Y HH:mm:ss')}\nEnde: ${moment(e.expired).format('D.M.Y HH:mm:ss')}`))}/>
                    ))}
                    <ChartWrapper data={this.buildExerciseData(graphData.exams, 'Prüfungssimulation', examLabels)}
                                  type="bar"/>
                    {Object.keys(graphData.specificExercises).map(key => {
                        const exercise = graphData.specificExercises[key];
                        if (!exercise.exercises[0]) return null;
                        const exerciseLabels = exercise.exercises.map((e) => (`Punkte: ${e.rating}\nStart: ${moment(e.started).format('D.M.Y HH:mm:ss')}\nAbgegeben: ${moment(e.finished).format('D.M.Y HH:mm:ss')}`));
                        return (<ChartWrapper key={exercise.exercises[0].exercise_title}
                                              data={this.buildExerciseData(exercise.exercises, exercise.exercises[0].exercise_title, exerciseLabels)}
                                              type="bar"/>)
                    })}
                </div>
            </div>
        );
    }
}

/* istanbul ignore next */
function mapStateToProps(state) {
    return {
        products: state.products,
        customers: state.home.customers,
    };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({...actions}, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Graphs);



// WEBPACK FOOTER //
// ./src/features/products/Graphs.js